import React, { useEffect, useRef, useState } from 'react';
import { Animated, ImageBackground, Linking, View } from 'react-native';

import B from '../../../components/Bold';
import { Button, Text, TextInput, useTheme } from 'react-native-paper';
import { NavigationWithProps } from '../../../core/Types';
import { LoginNavParamList } from '../Login';
import { useToast } from 'react-native-toast-notifications';
import { useAuth } from '../../../core/api/auth';
import { hasLengthBetween, isEmpty, isUndefinedOrNull, isValidPassword } from '../../../core/forms/forms';
import TextFormField from '../../../components/TextFormField';

const LoginEmailStep: React.FC<NavigationWithProps<{}, LoginNavParamList, "LoginEmail">> = ({ navigation, route }) => {
    const opacityAnim = useRef(new Animated.Value(0)).current;

    const { therapistId, clinicId } = route.params || {};

    const theme = useTheme();
    const auth = useAuth();
    const toast = useToast();

    const [loading, setLoading] = useState<boolean>(false);

    const [email,] = useState<string>(route.params.email);
    const [password, setPassword] = useState<string>("");

    const logIn = async () => {
        setLoading(true);

        if (validatePassword(password)) {
            onError();
            setLoading(false);
            return;
        }

        auth.emailLogin(email, password).then(() => {
            console.log('Success:', 'Success');
            toast.show("Sesión iniciada exitosamente", { duration: 1000 });
            setTimeout(() => {
                if (therapistId && clinicId) {
                    location.replace(`/therapist?id=${therapistId}&clinic=${clinicId}`);
                } else {
                    location.replace("/");
                }
            }, 1000);
        }).catch(() => {
            onError();
        }).finally(() => {
            setLoading(false);
        });

    };

    const onError = () => {
        console.log('Error:', 'Error');
        toast.show("Email o contraseña incorrectos", { duration: 1000 });
    };

    const openTermsAndConditions = () => {
        Linking.openURL("https://psicopro.co/terminos-y-condiciones/");
    };

    const openPrivacyPolicy = () => {
        Linking.openURL("https://psicopro.co/politica-de-privacidad/");
    };

    const validatePassword = (password: string): string | undefined => {
        if (isUndefinedOrNull(password) || isEmpty(password)) {
            return "La contraseña es obligatoria";
        }

        if (!hasLengthBetween(password, 8, 100)) {
            return "La contraseña debe tener entre 8 y 100 caracteres";
        }

        if (!isValidPassword(password)) {
            return "Una mayúscula, una minúscula, un número y un carácter especial";
        }
    };

    useEffect(() => {
        Animated.timing(opacityAnim, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
        }).start();
    }, []);

    return (
        <Animated.View style={{ height: "100%", opacity: opacityAnim }}>
            <ImageBackground
                style={{
                    height: "100%",
                    flexDirection: 'column',
                }}
                source={require("../../../../assets/img/scenes/fondo_marco.png")}>

                <View style={{
                    marginTop: 10,
                }}>
                    <Button
                        style={{ width: 100, marginLeft: 10 }}
                        icon="arrow-left"
                        textColor={theme.colors.primary}
                        onPress={() => navigation.goBack()}>
                        Volver
                    </Button>
                </View>

                <View style={{
                    marginTop: 100,
                }}>
                    <Text style={{
                        fontSize: 20,
                        textAlign: 'center',
                        marginBottom: 10,
                        color: theme.colors.onTertiaryContainer,
                    }}>
                        <B>Iniciar sesión en Kyra</B>
                    </Text>
                    <View style={{
                        marginHorizontal: 20,
                        marginBottom: 10
                    }}>
                        <TextFormField
                            label="Email"
                            value={email}
                            editable={false}
                            mode="outlined"
                        />
                        <TextFormField
                            label="Contraseña"
                            value={password}
                            secureTextEntry={true}
                            onChangeText={setPassword}
                            mode="outlined"
                        />
                        <Button
                            style={{ borderRadius: 5 }}
                            mode="contained"
                            onPress={logIn}
                            loading={loading}
                            disabled={!password}
                        >
                            Iniciar sesión
                        </Button>
                    </View>

                    <Button
                        mode="text"
                        onPress={() => navigation.navigate("PasswordRestore", { email, therapistId, clinicId })}
                        loading={loading}
                    >
                        He olvidado mi contraseña
                    </Button>
                </View>
                <Text style={{
                    marginTop: "auto",
                    marginBottom: 130,
                    fontSize: 18,
                    textAlign: "center",

                }}>
                    Continuando aceptas los <Text onPress={openTermsAndConditions}><B>Términos y Condiciones</B> </Text>
                    y la <Text onPress={openPrivacyPolicy}><B>Política de privacidad</B></Text>.
                </Text>
            </ImageBackground>
        </Animated.View >
    );
}

export default LoginEmailStep;
